module.exports = __webpack_public_path__ + "static/media/gasStation.d5283d26.svg";